import { render, staticRenderFns } from "./Budgets.vue?vue&type=template&id=67a0e7dc&scoped=true&"
import script from "./Budgets.vue?vue&type=script&lang=js&"
export * from "./Budgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a0e7dc",
  null
  
)

export default component.exports